import { getBarcodeLayoutData } from "@api/barcode";
import { STORAGE, storeData } from "@utils/Storage";

export function* setBarcodeSage(action: any): any {
  /**
   * 2次元バーコードレイアウト情報
   */
  try {
    const { location_id } = action.payload;
    var data = yield getBarcodeLayoutData(location_id);
    storeData(STORAGE.BARCODE_LAYOUT, JSON.stringify(data?.data));
  } catch (error) {
    console.log(error);
  }
}
